import { isValidEmail } from 'core-components/library/validation'

export interface IQuestion {
  key: number
  translationKey: string
  answersType: string
  required: boolean
  placeholder?: string
  validateFunction?: (value: string) => Promise<string>
}

interface IAnswer {
  key: number
  questionKey: number
  translationKey: string
  needElaborate: boolean
}

interface IConfig {
  questions: IQuestion[]
  answers: IAnswer[]
}

export const configuration = (): IConfig => {
  return {
    questions: [
      {
        key: 1,
        translationKey: 'omni-question-1',
        answersType: 'Radio',
        required: true,
      },
      {
        key: 2,
        translationKey: 'omni-question-2',
        answersType: 'Radio',
        required: true,
      },
      {
        key: 3,
        translationKey: 'omni-question-3',
        answersType: 'Radio',
        required: true,
      },
      {
        key: 4,
        translationKey: 'omni-question-4',
        answersType: 'ValidateInput',
        placeholder: 'Email',
        required: false,
        validateFunction: async (value: string) => (value ? isValidEmail(value) : ''),
      },
    ],

    answers: [
      {
        key: 1,
        questionKey: 1,
        translationKey: 'omni-answer-1',
        needElaborate: false,
      },
      {
        key: 0,
        questionKey: 1,
        translationKey: 'omni-answer-2',
        needElaborate: true,
      },
      {
        key: 1,
        questionKey: 2,
        translationKey: 'omni-answer-1',
        needElaborate: false,
      },
      {
        key: 0,
        questionKey: 2,
        translationKey: 'omni-answer-2',
        needElaborate: true,
      },
      {
        key: 1,
        questionKey: 3,
        translationKey: 'omni-answer-1',
        needElaborate: true,
      },
      {
        key: 0,
        questionKey: 3,
        translationKey: 'omni-answer-2',
        needElaborate: false,
      },
      {
        key: 1,
        questionKey: 4,
        translationKey: '',
        needElaborate: true,
      },
    ],
  }
}
